import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';

// Importar componentes lazy com Suspense
import {
  ProductionOrdersPageWithSuspense
} from './domains/Production/ProductionOrdersPage.lazy';

import {
  SalesOrdersPageWithSuspense
} from './domains/Sales/SalesOrdersPage.lazy';

import {
  ClientOrdersPageWithSuspense
} from './domains/Client/ClientOrdersPage.lazy';

import {
  AdminOrdersPageWithSuspense
} from './domains/Admin/AdminOrdersPage.lazy';

// Loading genérico para fallback
const GenericLoading = () => (
  <div className="h-full w-full flex flex-col bg-navy-900 min-w-[285px]">
    <div className="p-4 border-b border-navy-800">
      <div className="animate-pulse flex items-center space-x-3">
        <div className="h-8 w-32 bg-navy-800 rounded"></div>
        <div className="h-6 w-24 bg-navy-800 rounded"></div>
      </div>
    </div>
    <div className="flex-1 p-4">
      <div className="animate-pulse space-y-3">
        <div className="h-10 w-full bg-navy-800 rounded"></div>
        <div className="h-8 w-3/4 bg-navy-800 rounded"></div>
        <div className="h-8 w-1/2 bg-navy-800 rounded"></div>
      </div>
    </div>
  </div>
);

interface OrdersPageFactoryProps {}

export const OrdersPageFactory: React.FC<OrdersPageFactoryProps> = () => {
  const navigate = useNavigate();
  const { role } = usePermissions();

  // Callbacks para navegação via React Router
  const handleBack = () => navigate('/main');
  const handleNavigateToExport = () => navigate('/exportar');

  // Mapear roles para componentes lazy com Suspense
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const roleComponentMap: Record<string, React.ComponentType<any>> = {
    'producao': ProductionOrdersPageWithSuspense,
    'vendedor': SalesOrdersPageWithSuspense,
    'revenda': SalesOrdersPageWithSuspense,
    'clientes_plus': SalesOrdersPageWithSuspense,
    'cliente': ClientOrdersPageWithSuspense,
    'admin': AdminOrdersPageWithSuspense
  };

  const Component = roleComponentMap[role] || SalesOrdersPageWithSuspense;

  return (
    <Suspense fallback={<GenericLoading />}>
      <Component onBack={handleBack} onNavigateToExport={handleNavigateToExport} />
    </Suspense>
  );
};
